var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8665 21.711L19.7224 22.5781V21.3598V8.71875C19.7224 8.5934 19.8239 8.5 19.9318 8.5C20.0397 8.5 20.1412 8.5934 20.1412 8.71875V21.3598V22.5781L20.9971 21.711L25.462 17.1874C25.5411 17.1072 25.6732 17.1072 25.7523 17.1874C25.835 17.2712 25.835 17.4163 25.7523 17.5001L20.077 23.2501C19.9979 23.3303 19.8658 23.3303 19.7866 23.2501L14.1113 17.5001C14.0286 17.4163 14.0286 17.2712 14.1113 17.1874C14.1904 17.1072 14.3225 17.1072 14.4017 17.1874L18.8665 21.711ZM10.9188 23.0938V27.4062C10.9188 28.8666 12.0898 30.0625 13.5471 30.0625H26.3166C27.7738 30.0625 28.9448 28.8666 28.9448 27.4062V23.0938C28.9448 22.9684 29.0463 22.875 29.1542 22.875C29.2621 22.875 29.3636 22.9684 29.3636 23.0938V27.4062C29.3636 29.1218 27.994 30.5 26.3166 30.5H13.5471C11.8696 30.5 10.5 29.1218 10.5 27.4062V23.0938C10.5 22.9684 10.6015 22.875 10.7094 22.875C10.8173 22.875 10.9188 22.9684 10.9188 23.0938Z",
    fill: "#3A4043",
    stroke: "#778187"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/IconDownload.6a7dcad962b8998e4506ba528cefe1bb.svg";
export { ForwardRef as ReactComponent };